import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { ProviderService } from '@services/provider.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { SelectModule } from 'primeng/select';
import { ToastService } from '@utils/toast.service';
import { TableModule } from 'primeng/table';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { AntecedenteService } from '@services/antecedente.service';

@Component({
  selector: 'app-federal',
  imports: [
    CommonModule,
    BackboneComponent,
    BreadcrumbComponent,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TabViewModule,
    InputTextModule,
    SelectModule,
    TableModule,
    InputGroupAddonModule,
    InputGroup,
    IconFieldModule,
    InputIconModule,
    InputMaskModule,
  ],
  templateUrl: './federal.component.html',
  styleUrl: './federal.component.scss',
})
export class FederalPage {
  private formBuilder = inject(FormBuilder);
  private antecedenteService = inject(AntecedenteService);
  private providerService = inject(ProviderService);
  private toastService = inject(ToastService);

  public isSaving = false;

  public formUpload = this.formBuilder.group({
    curp: [null, Validators.required],
    provider: [null, [Validators.required]],
  });

  public providers: any[] = [];
  public list: any[] = [];
  public searchValue: string | undefined;

  ngOnInit() {
    this.providerService.module('antecedente-federal').then((data) => (this.providers = data));

    this.refresh();
  }

  refresh = async () => {
    await this.antecedenteService.federalList().then((response) => (this.list = response));
  };

  get curp() {
    return this.formUpload.get('curp');
  }
  set curp(value: any) {
    this.curp.setValue(value);
  }

  get provider() {
    return this.formUpload.get('provider');
  }

  save = async () => {
    this.isSaving = true;

    const myFormData = new FormData();

    myFormData.append('curp', this.curp.value);
    myFormData.append('provider', this.provider?.value ?? '');

    this.antecedenteService
      .federalCreate(myFormData)
      .then(() => {
        this.toastService.success('Guardado');
        this.formUpload.reset();
        this.refresh();
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error.');
      })
      .finally(() => (this.isSaving = false));
  };
}
